import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, Mail, ShieldCheck } from "lucide-react";
import { useState, useEffect } from "react";
import api from "@/lib/api";

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [counts, setCounts] = useState({ unread_messages: 0, pending_requests: 0 });

  useEffect(() => {
    if (!user) return;
    const load = () => api.get("/messages/unread-count").then((r) => setCounts(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, [user]);

  const nlink = ({ isActive }) =>
    `text-sm tracking-wide transition-colors ${isActive ? "text-[#C93B3B]" : "text-[#F7ECEB] hover:text-[#C93B3B]"}`;

  return (
    <header className="tt-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <span className="font-serif text-2xl tracking-tight text-[#F7ECEB]">Touche</span>
          <span className="text-[#E58B5E] font-serif text-2xl">.today</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          <NavLink to="/practitioners" className={nlink} data-testid="nav-practitioners">Practitioners</NavLink>
          <NavLink to="/membership" className={nlink} data-testid="nav-membership">Membership</NavLink>
          <NavLink to="/resources" className={nlink} data-testid="nav-resources">Library</NavLink>
          <NavLink to="/community" className={nlink} data-testid="nav-community">Community</NavLink>
          <NavLink to="/shop" className={nlink} data-testid="nav-shop">Shop <span className="ml-1 text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-[#2E1E1E] text-[#E58B5E]">Soon</span></NavLink>
          <NavLink to="/apply" className={nlink} data-testid="nav-apply">Become a Cuddler</NavLink>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" className="text-sm text-[#C93B3B] flex items-center gap-1" data-testid="header-admin-link" title="Admin">
                  <ShieldCheck className="w-4 h-4" /> Admin
                </Link>
              )}
              {user.practitioner_id && (
                <Link to="/practitioner" className="text-sm text-[#C93B3B] relative" data-testid="header-portal-link">
                  Portal
                  {counts.pending_requests > 0 && (
                    <span className="absolute -top-2 -right-4 text-[10px] bg-[#E58B5E] text-[#110D0D] rounded-full px-1.5 font-semibold" data-testid="pending-requests-badge">{counts.pending_requests}</span>
                  )}
                </Link>
              )}
              <Link to="/messages" className="text-[#F7ECEB] hover:text-[#C93B3B] relative" data-testid="header-messages-btn" title="Messages">
                <Mail className="w-5 h-5" />
                {counts.unread_messages > 0 && (
                  <span className="absolute -top-2 -right-2 text-[10px] bg-[#C93B3B] text-white rounded-full px-1.5 font-semibold" data-testid="unread-badge">{counts.unread_messages}</span>
                )}
              </Link>
              <Link to="/dashboard" className="btn-ghost text-sm" data-testid="header-dashboard-btn">Dashboard</Link>
              <button onClick={async () => { await logout(); nav("/"); }} className="btn-primary text-sm" data-testid="header-logout-btn">
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-ghost text-sm" data-testid="header-login-btn">Sign in</Link>
              <Link to="/register" className="btn-primary text-sm" data-testid="header-signup-btn">Become a member</Link>
            </>
          )}
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2"
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          <Menu className="w-6 h-6 text-[#F7ECEB]" />
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#382A2A] bg-[#110D0D]">
          <div className="px-6 py-4 flex flex-col gap-3">
            <Link to="/practitioners" onClick={() => setOpen(false)} className="text-sm py-2">Practitioners</Link>
            <Link to="/membership" onClick={() => setOpen(false)} className="text-sm py-2">Membership</Link>
            <Link to="/resources" onClick={() => setOpen(false)} className="text-sm py-2">Library</Link>
            <Link to="/community" onClick={() => setOpen(false)} className="text-sm py-2">Community</Link>
            <Link to="/shop" onClick={() => setOpen(false)} className="text-sm py-2">Shop <span className="ml-1 text-[10px] uppercase tracking-wider text-[#E58B5E]">Soon</span></Link>
            <Link to="/apply" onClick={() => setOpen(false)} className="text-sm py-2">Become a Cuddler</Link>
            {user ? (
              <>
                <Link to="/messages" onClick={() => setOpen(false)} className="text-sm py-2">Messages</Link>
                {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="text-sm py-2 text-[#C93B3B]">Admin</Link>}
                {user.practitioner_id && <Link to="/practitioner" onClick={() => setOpen(false)} className="text-sm py-2 text-[#C93B3B]">Portal</Link>}
                <Link to="/dashboard" onClick={() => setOpen(false)} className="btn-primary text-sm text-center">Dashboard</Link>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="btn-ghost text-sm text-center">Sign in</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="btn-primary text-sm text-center">Become a member</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
